import { Component, HostListener, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { CheckUserBraceletComponent } from 'src/app/components/sling/check-user-bracelet/check-user-bracelet.component';
import { SlingConfig } from 'src/app/models';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { SlingConfigService } from 'src/app/services/sling-config.service';
import { MessageUtil } from 'src/app/utils/message.util';
import { LandExitComponent } from '../land-exit/land-exit.component';
import Swal from 'sweetalert2';
import { MultiQueue } from 'src/app/models/multi-queue';
import { SlingMultiQueueService } from 'src/app/services/sling-multi-queue/sling-multi-queue.service';


@Component({
  selector: 'app-sling-check',
  templateUrl: './sling-check.component.html',
  styleUrls: ['./sling-check.component.scss']
})
export class SlingCheckComponent implements OnInit {

  isMobile = false;
  slingConfig: SlingConfig;
  mainActiveIndex = 0;
  downActiveIndex = 0;
  upActiveIndex = 0;
  slingConfigMultQueue: MultiQueue[] = [];
  slingConfigMultQueueUp: MultiQueue[] = [];

  @HostListener('window:resize', ['$event']) onScroll(event?: any): void {
    this.checkMobile();
    this.showHideSideNav();
  }

  constructor(
    private slingConfigService: SlingConfigService,
    private messageUtil: MessageUtil,
    private dialog: DialogService,
    private slingMultQueueService: SlingMultiQueueService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.slingConfig = await this.loadSlingConfig();
    this.checkMobile();
    this.loadSlingMultQueue();
    this.loadSlingMultQueueUp();
  }

  onChangeMainTab($event) {
    this.mainActiveIndex = $event.index;
  }

  onChangeSubTab($event, type: string) {
    if (type === 'down') {
      this.downActiveIndex = $event.index;
    } else if (type === 'up') {
      this.upActiveIndex = $event.index;
    }
  }

  reload() {
    const mainIndex = this.mainActiveIndex;
    const downIndex = this.downActiveIndex;
    const upIndex = this.upActiveIndex;
    
    this.mainActiveIndex = 99;
    this.downActiveIndex = 99;
    this.upActiveIndex = 99;
    
    setTimeout(() => {
      this.mainActiveIndex = mainIndex;
      this.downActiveIndex = downIndex;
      this.upActiveIndex = upIndex;
    }, 1);
  }

  loadSlingMultQueue():void
  {
    this.slingMultQueueService.getAllMarinaActive(true).subscribe(
      (data: any[]) => {
        this.slingConfigMultQueue = data;
        console.log(data);
      },
      (error) => {
        Swal.fire('Erro ao buscar lista de filas');
      }
    );
  }

  loadSlingMultQueueUp():void
  {
    this.slingMultQueueService.getAllMarinaActive(true).subscribe(
      (data: any[]) => {
        this.slingConfigMultQueueUp = data;
        console.log('Filas de subida:', data);
      },
      (error) => {
        Swal.fire('Erro ao buscar lista de filas de subida');
      }
    );
  }

  openModalUserInfo(): void {
    this.dialog.open(CheckUserBraceletComponent, {
      width: '400px',
      showHeader: false,
      dismissableMask: true
    });
  }

  checkMobile(): void {
    this.isMobile = window.innerWidth <= 576;
  }

  showHideSideNav(): void {
    BroadcastService.get('showHideSidenav').emit(false);
  }

  async loadSlingConfig(): Promise<SlingConfig> {
    return new Promise<SlingConfig>(
      async (resolve) => {
        this.slingConfigService.getSlingConfig().subscribe(
          async (data) => {
            resolve(data[0]);
          },
          async (error) => {
            const exception = error.error.data.exception;
            this.messageUtil.generateMessage(exception.type, exception.title, exception.message);
            resolve(null);
          }
        );
      }
    );
  }

  enableSlingDown(): boolean {
    return this.mainActiveIndex === 0 && this.downActiveIndex === 0;
  }

  enableSlingDownMult(i:number): boolean {
    return this.mainActiveIndex === 0 && this.downActiveIndex === i;
  }

  enableSlingWater(): boolean {
    return this.mainActiveIndex === 1;
  }

  enableSlingUpMain(): boolean {
    return this.mainActiveIndex === 2 && this.upActiveIndex === 0;
  }

  enableSlingUpMult(i:number): boolean {
    return this.mainActiveIndex === 2 && this.upActiveIndex === i;
  }

  openLandExitModal(): void {
    this.dialog.open(LandExitComponent, {
      width: '50%',
      height: '40vh',
      header: 'SAÍDA POR TERRA',
    });
  }

}
